module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sailing@2x_0b244b.jpg";